import { gql, useQuery } from '@apollo/client';
import { GetV2ReportTypesQuery } from '../types';

export const GET_V2_REPORT_TYPES_QUERY = gql`
  query GetV2ReportTypes {
    getV2ReportTypes
  }
`;

export const useGetV2ReportTypes = () => useQuery<GetV2ReportTypesQuery>(GET_V2_REPORT_TYPES_QUERY);
